// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__rhc9v","error":"Notification_error__H9D18","success":"Notification_success__YotBa"};